module.exports = __webpack_public_path__ + "img/img-antros.8b936bdc.png";